import styled, {css} from 'styled-components'

export const StyledCardCheckbox = styled.button<{$checked: boolean}>`
    ${({theme, $checked}) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing * 3}px;
        padding: ${theme.spacing * 3}px;
        border-radius: 8px;
        border: 2px solid ${$checked ? theme.palette.primary['500'] : theme.palette.neutral['200']};
        background: ${$checked ? theme.palette.primary['50'] : theme.palette.neutral.white};
        cursor: pointer;
        text-align: left;
        transition: ${theme.transition};
        width: 100%;

        &:hover {
            border-color: ${$checked ? theme.palette.primary['500'] : theme.palette.neutral['300']};
        }
    `}
`

export const StyledCheckSquare = styled.span<{$checked: boolean}>`
    ${({theme, $checked}) => css`
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: 1px solid ${$checked ? theme.palette.primary['600'] : theme.palette.neutral['300']};
        background: ${$checked ? theme.palette.primary['600'] : theme.palette.neutral.white};
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        & svg {
            width: 12px;
            height: 12px;
            color: ${theme.palette.neutral.white};
        }
    `}
`

export const StyledIconTile = styled.span<{$checked: boolean}>`
    ${({theme, $checked}) => css`
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: ${$checked ? theme.palette.primary['600'] : theme.palette.neutral['100']};
        color: ${$checked ? theme.palette.neutral.white : theme.palette.neutral['600']};

        & svg {
            width: 16px;
            height: 16px;
        }
    `}
`

export const StyledCardTexts = styled.span`
    ${({theme}) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing * 0.5}px;

        & > strong {
            ${theme.typography.textSm};
            font-weight: 500;
            color: ${theme.palette.neutral['900']};
        }

        & > small {
            ${theme.typography.textXs};
            color: ${theme.palette.neutral['500']};
        }
    `}
`
